<p-table #bins [columns]="binCols" [value]="binData" [lazy]="true" [rowsPerPageOptions]="rowsPerPage" [paginator]="true"
    [totalRecords]="totalRecordBins" (onPage)="getBinData($event)" [showCurrentPageReport]="true" [rows]="pageSize"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [scrollable]="true"
    [style]="{ width: '100%' }" [resizableColumns]="true" styleClass="p-datatable-gridlines">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="
                let col of columns
            ">
                <th *ngIf="col.show" [pSortableColumn]="
                    col.field
                " style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    {{ col.header }}
                    <ng-container>
                        <span class="pi pi-filter p-mr-2 filtericon" [ngClass]="{
                            blink_me:
                                col
                                    .value
                                    .length >
                                0
                        }" (click)="
                            $event.stopPropagation();
                            curCol =
                                col;
                            oppp.toggle(
                                $event
                            )
                        ">
                        </span>
                    </ng-container>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
            <ng-container *ngFor="let col of columns">
                <td *ngIf="col.show" (click)="col.field ==
                    'qty'? onBinRowSelect(rowData): col.field =='capacity'? openEditCapacity(rowData): ''">
                    {{rowData[col.field]}}
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr>
            <td colspan="7" style="display: block;" class="p-text-center">
                {{noBinsFindOrLoadingText}}
            </td>
        </tr>
    </ng-template>
</p-table>
<p-overlayPanel #oppp [showCloseIcon]="true" appendTo="body" [dismissable]="true">
    <ng-template pTemplate>
        <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
                                    (ngModelChange)="onBinFilter(curCol.value,curCol.field)" placeholder="Search by {{ curCol.header }}"
                                    class="p-column-filter" />
    </ng-template>
</p-overlayPanel>